import React from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import CategorySlider, { Props as CategorySliderProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/category-slider';

export interface Props {
  data: CategorySliderProps;
}

const CategorySliderTastic: React.FC<Props> = ({ data }) => {
  return (
    <CategorySlider
      {...data}
      tileLabelClassName={CHIPOTLE_CONTENT_LOOK.categoryTileLabelClassName}
      background={CHIPOTLE_CONTENT_LOOK.categorySliderBackground}
    />
  );
};

export default CategorySliderTastic;
